module.exports = __webpack_public_path__ + "img/ru.e3ee3b09.svg";